//regex that only allows the value to be numbers or the '+' sign followed by numbers
export const filterPhonePrefix = (value: unknown) => {
  return /^\+?[0-9]*$/.test(value as string) || value === '';
};

//regex that allows the valuye to be only numbers
export const filterPhoneNumber = (value: unknown) => {
  return /^[0-9]*$/.test(value as string) || value === '';
};
